import React from "react";
import { ContextMenu, ContextMenuItem } from "src/components/ContextMenu";
import { ApiResponseType, PropsType } from "./types";
import { usePremisesContextMenu } from "./usePremisesContextMenu";
import { useAppContext } from "src/context/AppContext";

export const PremisesContextMenu: React.FC<PropsType> = (props) => {
  const {
    handleOnClickView,
    handleOnClickDuplicate,
    handleOnClickBulkDuplicate,
    handleOnResultBulkDuplicate,
    handleOnErrorBulkDuplicate,
    handleOnClickDelete,
    handleOnClickClose,
    showCTEntrance,
    showDeleteDraftEntrance,
    showDuplicateRequestEntrance,
    handleOnResultClose,
    handleOnErrorClose,
  } = usePremisesContextMenu(props);
  const {
    context: { featureFlags },
  } = useAppContext();

  return (
    <ContextMenu minWidth="155px" consumerAnchorEl={props.consumerAnchorEl}>
      <ContextMenuItem onHandleClick={handleOnClickView}>View</ContextMenuItem>
      {showDuplicateRequestEntrance && (
        <ContextMenuItem onHandleClick={handleOnClickDuplicate}>
          Duplicate...
        </ContextMenuItem>
      )}
      {showDuplicateRequestEntrance && (
        <ContextMenuItem
          onHandleClick={handleOnClickBulkDuplicate}
          onResult={handleOnResultBulkDuplicate}
          onError={handleOnErrorBulkDuplicate}
        >
          Bulk Duplicate...
        </ContextMenuItem>
      )}
      {showDeleteDraftEntrance && (
        <ContextMenuItem onHandleClick={handleOnClickDelete}>
          Delete...
        </ContextMenuItem>
      )}
      {showCTEntrance && featureFlags.showCloseButtonInContextMenu && (
        <ContextMenuItem<ApiResponseType>
          onHandleClick={handleOnClickClose}
          onResult={handleOnResultClose}
          onError={handleOnErrorClose}
        >
          Close...
        </ContextMenuItem>
      )}
    </ContextMenu>
  );
};
